import { ChangeDetectionStrategy, Component, computed, ElementRef, input, viewChild } from '@angular/core';
import { RootDirective } from '@pure/hive';
import { EoneCapacityExpansionRenderInfo } from '../../../../data/models/recommendations.models';
import { mountHighchartsChart } from '../../utils/recommendations-chart-utils';
import { registerAsCardPlugin } from '../../services/recommendation-component-registry.service';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const EONE_CAPACITY_EXPANSION_CARD_PLUGIN_NAME = 'EoneCapacityExpansionCardPluginComponent';

/**
 * Plugin component for Evergreen//One capacity expansion recommendation card body.
 *
 * Renders the mini sparkline (Highcharts mounted directly), the projected-percent
 * pills, the date / "+N days" row, and the "Expand from X TiB to Y TiB Reserved"
 * summary line. The recommendation card shell (header badge, target name, footer
 * buttons) is provided by `RecommendationCardTemplateComponent`.
 *
 * This component does no chart calculation — `RecommendationProcessingService`
 * pre-builds `renderInfo.sparklineOptions` with data and styling baked in;
 * this component just calls `new Chart(...)` against the host container.
 */
@Component({
    selector: 'eone-capacity-expansion-card-plugin',
    templateUrl: './eone-capacity-expansion-card-plugin.component.html',
    styleUrls: ['./eone-capacity-expansion-card-plugin.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RootDirective],
})
export class EoneCapacityExpansionCardPluginComponent {
    renderInfo = input.required<EoneCapacityExpansionRenderInfo>();

    readonly sparklineContainer = viewChild<ElementRef<HTMLDivElement>>('sparklineContainer');

    constructor() {
        mountHighchartsChart(
            this.sparklineContainer,
            computed(() => this.renderInfo().sparklineOptions),
        );
    }
}

registerAsCardPlugin(EONE_CAPACITY_EXPANSION_CARD_PLUGIN_NAME, EoneCapacityExpansionCardPluginComponent);
